// app/(lib)/actions/homePageAction.ts
"use server";

import { homepageService } from "../services/homepageService";
import { extractDomain, getGlobalParams } from "../utils/domain";

export async function getWhyYoungEngineersAction() {
  try {
    const domain = await extractDomain();
    const { franchiseeId } = await getGlobalParams();
    const allData = await homepageService.fetchByDomain(domain, franchiseeId);

    // Load static data for images
    const staticData = await import("@/src/data/home.json");
    const staticSlides = staticData.default.whyYoungEngineers.slides;

    // Extract API data from default content
    const whyYEData = allData.default?.whyYoungEngineers;
    if (!whyYEData) {
      return {
        success: false,
        data: null,
      };
    }

    // Parse API sliders
    const apiSliders = typeof whyYEData.sliders === 'string'
      ? JSON.parse(whyYEData.sliders || '[]')
      : whyYEData.sliders || [];

    // Merge: static images + dynamic text
    const mergedSliders = staticSlides.map((staticSlide: any, index: number) => {
      const apiSlide = apiSliders[index] || {};
      return {
        sliderHeading: apiSlide.sliderHeading || staticSlide.title.split("—")[0] || `Feature ${index + 1}`,
        title: apiSlide.title || staticSlide.title,
        description: apiSlide.description || staticSlide.desc,
        image: staticSlide.image, // ← STATIC IMAGE from home.json
      };
    });

    return {
      success: true,
      data: {
        mainHeading: whyYEData.mainHeading || "Why Young Engineers",
        sliders: mergedSliders,
        ctaButtonText: whyYEData.ctaButtonText || "Discover Programs",
      },
    };
  } catch (error) {
    console.error("[getWhyYoungEngineersAction] Error:", error);
    return {
      success: false,
      data: null,
    };
  }
}

// Generic action for future sections
export async function getHomePageDataAction() {
  try {
    const domain = await extractDomain();
    const { franchiseeId, lang } = await getGlobalParams();
    const homePageData = await homepageService.fetchByDomain(domain, franchiseeId, lang);
    return {
      success: true,
      data: homePageData,
    };
  } catch (error) {
    console.error("[getHomePageDataAction] Error:", error);
    return {
      success: false,
      data: null,
    };
  }
}
